<script>
import { mergeData } from 'vue-functional-data-merge'

export default {
  name: 'BaseShortcut',

  functional: true,

  props: {
    title: {
      type: String
    },
    combinations: {
      type: Array,
      rquired: true
    },
    divider: {
      type: String
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },

  render (createElement, { props, data, parent }) {
    const { title, combinations, divider = parent.$t('shortcuts.plusDivider'), isSmall } = props

    return [
      createElement('div', mergeData(data, { class: ['c-base-shortcut', { 'c-base-shortcut--is-small': isSmall }] }), [
        createElement('div', { class: 'c-base-shortcut__keys' }, combinations.reduce((result, element, index, array) => {
          const key = element.content
            ? createElement('span', { class: 'c-base-shortcut__box' }, [createElement('span', { class: 'c-base-shortcut__content' }, element.content)])
            : createElement('div', { class: 'c-base-shortcut__box' }, [createElement('font-awesome-icon', { class: 'c-base-shortcut__icon', props: { icon: element.icon } })])

          result.push(key)

          if (index < array.length - 1) {
            result.push(createElement('span', { class: 'c-base-shortcut__divider' }, divider))
          }

          return result
        }, [])),
        createElement('span', { class: 'c-base-shortcut__title' }, title)
      ])
    ]
  }
}
</script>
